// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3bqQV","placeholdersHeader":"styles_placeholdersHeader__Ubt21","editorStyle":"styles_editorStyle__1EIdc","placeholdersBox":"styles_placeholdersBox__1kFPr"};